import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { Navigate, routes } from "@shared/lib/react-router";
import { JournalsTitle } from "./ui";

const titleChildren: RouteObject[] = [
  {
    path: "",
    element: createElement(Navigate, { to: "general", replace: true }),
  },
  { path: "general", element: null },
  { path: "notes", element: null },
  { path: "history", element: null },
  { path: "details", element: null },
  { path: "amendments", element: null },
  { path: "amendments/new", element: null },
  { path: "amendments/view/:requestId", element: null },
  { path: "new", element: null },
  { path: "version/:titleVersionId", element: null },
];

export const JournalsTitleRoute = (...rest: RouteObject[]): RouteObject => {
  return {
    path: `${routes.journals.title()}`,
    element: createElement(JournalsTitle),
    children: [...titleChildren, ...rest],
  };
};


export const JournalsVersionTitleRoute = (): RouteObject => {
  return {
    path: `${routes.journals.journalVersionTitle()}`,
    element: createElement(JournalsTitle),
    children: titleChildren,
  };
};

export { JournalsAmendmentsStatusBadge } from "./ui";
